import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore'
import { BehaviorSubject } from 'rxjs';
import { User } from '../classes/user';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class AuthStore {

  constructor(
    private storage: Storage,
  ) { }

  auth = firebase.auth();
  fs = firebase.firestore();
  user = new BehaviorSubject(null as User);



  async initUser(uid: string) {
    return new Promise(async (resolve) => {
      let user = await this.getUserFromFirstore(uid);
      this.updateUser(user);
      return resolve(true)
    })
  }

  updateUser(user: User) {
    user = { ...user }
    user = Object.keys(user).length == 0 ? null : user
    this.user.next(user);
    this.storage.set('user', user)
  }


  forgotPassword(email: string) {
    return new Promise((resolve, reject) => {
      this.auth.sendPasswordResetEmail(email).then(() => {
        return resolve(true)
      }).catch((error) => {
        return reject(error)
      })
    })
  }


  login(email: string, password: string) {
    return new Promise((resolve, reject) => {
      this.auth.signInWithEmailAndPassword(email, password).then((result) => {
        let uid = result.user.uid;
        let user = this.getUserFromFirstore(uid) as unknown as User;
        this.updateUser(user);
        console.log(user)
        return resolve(true)
      }).catch((error) => {
        return reject(error)
      })
    })
  }

  logout() {
    return new Promise((resolve, reject) => {
      this.auth.signOut().then(result => {
        this.storage.remove('uid');
        this.storage.remove('plans');
        return resolve(true)
      }).catch((error) => {
        return reject(error)
      })
    })
  }

  deleteAccount() {
    return new Promise((resolve, reject) => {
      this.auth.currentUser.delete().then(() => {
        let uid = localStorage.getItem('uid');
        this.storage.remove('uid');
        this.storage.remove('plans');
        this.deleteUserFromFirestore(uid);
        return resolve(true)
      }).catch((error) => {
        return reject(error)
      })
    })
  }
  createUser(fname: string, lname: string, password: string, email: string) {
    let user = new User();
    user = { ...user };
    user.fname = fname;
    user.lname = lname;
    user.email = email;
    return new Promise((resolve, reject) => {
      this.auth.createUserWithEmailAndPassword(email, password).then(async (result) => {
        user.uid = result.user.uid;
        let newUser = await this.saveUserToFirestore(user);
        return resolve(newUser)
      }).catch((error) => {
        return reject(error)
      })
    })
  }


  saveUserToFirestore(user: User): Promise<User> {
    user = { ...user }
    user.path = 'users/' + user.uid;
    user.created = new Date().getTime();
    user.createdString = moment(user.created, 'x').format('LLLL')
    user.modified = new Date().getTime();
    user.modifiedString = moment(user.created, 'x').format('LLLL')


    return new Promise((resolve, reject) => {
      this.fs.doc('users/' + user.uid).set(user).then(() => {
        let newUser = this.getUserFromFirstore(user.uid) as unknown as User
        return resolve(newUser)
      })

    })
  }
  getUserFromFirstore(uid: string): Promise<User> {
    return new Promise((resolve, reject) => {
      this.fs.doc('/users/' + uid).get().then(user => {
        return resolve((user.data()) as User)
      }).catch((error) => {
        return reject(error)
      })
    })
  }

  updateUserToFirestore(user: User) {
    user = { ...user };
    user.modified = new Date().getTime();
    user.modifiedString = moment(user.created, 'x').format('LLLL')

    return new Promise((resolve, reject) => {
      this.fs.doc(user.path).set(user).then(() => {
        return resolve(true)
      }).catch((error) => {
        return reject(error)
      })
    })
  }

  deleteUserFromFirestore(uid: string) {
    return new Promise((resolve, reject) => {
      this.fs.doc(`users/${uid}`).delete().then(() => {
        return resolve(true);
      }).catch((error) => {
        return reject(error)
      })
    })
  }
}
